import React from 'react';
import map from 'lodash/map';

import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import Text from 'app/shared/core/Text';

type HdpTextSectionProps = {
  content: string;
  header: string;
};

class HdpTextSection extends React.Component<HdpTextSectionProps> {
  static displayName = 'HdpTextSection';

  render() {
    const { content, header } = this.props;

    if (!content) {
      return null;
    }

    const contentLines = content.split('\n');
    return (
      <HdpContentWrapper collapsable header={header} headerHtmlTag="h2">
        <Text size="md">
          <div className="HdpTextSection">
            {map(contentLines, (v, k) => {
              return (
                <span key={k}>
                  {v}
                  <br />
                </span>
              );
            })}
          </div>
        </Text>
      </HdpContentWrapper>
    );
  }
}

export default HdpTextSection;
